import * as types from "../ActionType";
import axios from "axios";
import { notifyError , notifysuccess } from "../../components/general/Notification";
import { hasExpirition } from "../../components/general/general-component/abstruct-component/useExpirition";
import { removeCommas } from "../../components/general/general-component/abstruct-component/FunctionRemoveCommas";
const END_POINT = process.env.REACT_APP_BASE_URL_ACCOUNTING;

const get = (arr,type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit= (type) => {
    return ({
        type: type 
    })
}

export const postTransaction = (state,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        let user_id = localStorage.getItem('XX')
        const body={
            descriptions: state.description,
            amount: parseInt(removeCommas(state.amount)),
            transaction_date: state.transaction_date,
            transaction_type: state.transaction_type,
            account_id: state.account_id
        }
        console.log(body)
        axios.post(`${END_POINT}/api/transactions`, body, {
            headers: {
                'Authorization': `Bearer ${token}`,
                "X-User-Id": user_id
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ADD_TRANSACTION));
                dispatch(loadTransactions());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}
export const loadTransactions = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/transactions`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data,types.GET_TRANSACTIONS));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}

export const getPageListTransaction = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/transactions/create`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res?.data?.data,types.PAGE_LIST_TRANSACTIONS));
            }
        }).catch((err) => {
            //notifyError(err.response.data.message)
        })
    }
}

export const cancelTransaction= (id,setloadDel,setIsDeleted,setIdDeleted) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/transactions/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.CANCEL_TRANSACTION));
                notifysuccess(res.data.message)
                //dispatch(loadUsers());
                setIsDeleted('deleted')
                setIdDeleted(id)
                setloadDel(false)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}

export const putTransaction = (id,name,email,password,role,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        const formValues = {
            name: name,
            email: email,
            role: role
        };
        if(password !== ''){
            formValues.password = password;
        }
        axios.put(`${END_POINT}/api/users/${id}`,formValues, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(edit(types.EDIT_TRANSACTION));
                dispatch(loadTransactions());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}


export const filterTransaction = (search_value,account_id,date,transaction_type,user_id,status, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA")
        setLoad(true);
        const queryParams = [];
        if (search_value !== '') queryParams.push(`filters[search_value]=${search_value}`);
        if (account_id !== '') queryParams.push(`filters[account_id]=${account_id}`);
        if (date !== '') queryParams.push(`filters[date]=${date}`);
        if (transaction_type !== '') queryParams.push(`filters[transaction_type]=${transaction_type}`);
        if (user_id !== '') queryParams.push(`filters[user_id]=${user_id}`);
        if (status !== null) queryParams.push(`filters[status]=${status}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/transactions?${finalQuery}`;
        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((res) => {
            setLoad(false);
             dispatch(get(res.data.data,types.GET_TRANSACTIONS));
        }).catch((err) => {;
            setLoad(false);
        });
    };
};


